<template>
  <v-card flat>
    <v-alert
      v-if="alertMsg.status"
      :timeout="alertMsg.timeout"
      :color="alertMsg.color"
      :type="alertMsg.type"
      dismissible
    >
      {{ alertMsg.text }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="getinformation"
      :search="search"
      item-key="biz_user_id"
      :loading="isLoading"
      class="elevation-1"
    >
      <template v-slot:item.id_type="{ item }">
        <span>{{ item.id_type ? item.id_type.value : null }}</span>
      </template>
      <template v-slot:item.occupation="{ item }">
        <span>{{ item.occupation ? item.occupation.value : null }}</span>
      </template>
      <template v-slot:item.nature_of_business="{ item }">
        <span>{{
          item.nature_of_business && typeof item.nature_of_business === "object"
            ? item.nature_of_business.value
            : item.nature_of_business
        }}</span>
      </template>
      <template v-slot:item.nationality="{ item }">
        <span>{{
          item.nationality ? item.nationality.nationality : null
        }}</span>
      </template>
      <template v-slot:item.id_first_page="{ item }">
        <v-avatar
          v-if="item.id_first_page"
          size="36px"
          @click="handleImageViewer(item.id_first_page)"
        >
          <img
            v-if="item.id_first_page"
            alt="Avatar"
            :src="item.id_first_page"
          />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>{{ $t("no_image") }}</span>
          </v-tooltip>
        </v-avatar>
      </template>
      <template v-slot:item.id_last_page="{ item }">
        <v-avatar
          v-if="item.id_last_page"
          size="36px"
          @click="handleImageViewer(item.id_last_page)"
        >
          <img v-if="item.id_last_page" alt="Avatar" :src="item.id_last_page" />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>{{ $t("no_image") }}</span>
          </v-tooltip>
        </v-avatar>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" max-width="700px" :persistent="isSaving">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                small
                dark
                class=""
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark left>mdi-account-plus </v-icon>
                {{ $t("add_personal") }}
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-divider class="p-0 m-0"></v-divider>
              <v-card-text>
                <v-form v-model="valid" ref="busApplicant">
                  <v-row>
                    <!-- <v-col
                      cols="12"
                      md="6"
                      class="d-flex pt-0"
                      v-for="(users, index) in Entitycheckbox"
                      :key="index"
                    >
                      <v-checkbox
                        v-model="editedItem.applicant_type"
                        :disabled="editedItem.biz_user_id ? true : false"
                        :error-messages="applicantErrors"
                        @input="$v.editedItem.applicant_type.$touch()"
                        :label="users.name"
                        :value="users.name"
                        hide-details
                      ></v-checkbox>
                    </v-col> -->

                    <v-col class="pt-4" cols="12" md="6">
                      <label class="ma-0 pa-0">
                        {{ $t("user_type") }}
                        <span style="color: #f00">*</span></label
                      >
                      <v-autocomplete
                        :placeholder="$t('user_type_placeholder')"
                        :items="Entitycheckbox"
                        :error-messages="applicantErrors"
                        @input="$v.editedItem.applicant_type.$touch()"
                        v-model="editedItem.applicant_type"
                        dense
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-4" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("fullName")
                        }}<span
                          v-if="validationFields.includes('Full Name')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-text-field
                        v-model="editedItem.full_name"
                        :error-messages="fnameErrors"
                        @input="$v.editedItem.full_name.$touch()"
                        dense
                        :placeholder="$t('fullName')"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0">{{ $t("Gender") }}</label>
                      <v-autocomplete
                        :placeholder="$t('gender_placeholder')"
                        :items="genderOptions"
                        v-model="editedItem.gender"
                        dense
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("date_of_birth_business")
                        }}<span
                          v-if="validationFields.includes('DOB')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >

                      <v-menu
                        ref="dobmenu"
                        v-model="dobmenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        :offset-x="true"
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.dob"
                            persistent-hint
                            clearable
                            v-on="on"
                            type="date"
                            dense
                            :error-messages="DOBerrors"
                            @input="$v.editedItem.dob.$touch()"
                            @change="ValidateAge"
                            :min="minDate"
                            :max="maxDate"
                            outlined
                          >
                          </v-text-field>
                        </template>
                      </v-menu>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0">{{
                        $t("country_of_birth_business")
                      }}</label>
                      <v-autocomplete
                        :placeholder="$t('country_of_birth_placeholder')"
                        :items="country_options"
                        item-text="name"
                        item-value="id"
                        v-model="editedItem.country_code"
                        outlined
                        required
                        dense
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("Nationality")
                        }}<span
                          v-if="validationFields.includes('Nationality')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-autocomplete
                        :placeholder="$t('nationality_placeholder')"
                        dense
                        v-model="editedItem.nationality_code"
                        :items="nationality_options"
                        item-text="name"
                        item-value="id"
                        :error-messages="nationalityErrors"
                        @input="$v.editedItem.nationality_code.$touch()"
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("Occupation")
                        }}<span
                          v-if="validationFields.includes('Designation')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-autocomplete
                        v-model="editedItem.occupation_code"
                        :items="occupation_options"
                        item-text="name"
                        item-value="id"
                        :error-messages="designationErrors"
                        @input="$v.editedItem.occupation_code.$touch()"
                        :placeholder="$t('occupation_placeholder')"
                        dense
                        outlined
                        required
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("emailAddress")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.email_id"
                        :error-messages="emailErrors"
                        @input="$v.editedItem.email_id.$touch()"
                        :placeholder="$t('email_placeholder')"
                        dense
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0">{{ $t("phoneNumber") }}</label>
                      <vue-phone-number-input
                        v-digits-only
                        default-country-code="MY"
                        @update="onChangeNumber"
                        :error="Boolean(editedItem.phone_number) && !isValidNumber"
                        v-model="editedItem.phone_number"
                        class=""
                      />
                      <span
                        v-if="editedItem.phone_number && !isValidNumber"
                        style="color: #ff5252; font-size: 12px"
                      >
                        {{ $t("invalid_phone_number") }}
                      </span>
                    </v-col>
                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('No of Shares')"
                    >
                      <label class="ma-0 pa-0"
                        >{{ $t("share_holder_percentage")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        :placeholder="$t('share_holder_percentage')"
                        v-model="editedItem.no_of_shares"
                        suffix="%"
                        type="number"
                        :rules="validations.sharesRules"
                        outlined
                        required
                        hide-spin-buttons
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("idType")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-select
                        v-if="validationFields.includes('ID Number')"
                        v-model="editedItem.id_type_code"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="validations.id_proofrules"
                        :items="idtypes_val"
                        item-text="name"
                        item-value="id"
                        outlined
                        required
                        :placeholder="$t('idtype_select_placeholder')"
                        dense
                      ></v-select>
                      <!-- <v-select
                    v-else
                    v-model="id_type_back"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :rules="validations.id_proofrules"
                    :items="idtypes_val"
                    item-text="name"
                    item-value="id"
                    :disabled="disableValues || disableBystatus"
                    outlined
                    required
                    :placeholder="$t('idtype_select_placeholder')"
                    dense
                  ></v-select> -->
                    </v-col>
                    <!-- <v-col class="pt-0" cols="12" md="6" v-if="validationFields.includes('ID Number')">
                          <label class="ma-0 pa-0">{{ $t("idType")
                          }}<span style="color: #f00">*</span></label>
                          <v-select item-text="name" item-value="id" v-model="editedItem.id_type_code"
                            :menu-props="{ bottom: true, offsetY: true }" :rules="validations.id_proofrules"
                            :items="idtypes" outlined required :placeholder="$t('idtype_select_placeholder')"
                            dense></v-select>
  
                        </v-col> -->
                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="!isMykad && !kycStatus"
                    >
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("isuueDate")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.id_issue_date"
                        v-if="validationFields.includes('ID Number')"
                        :rules="validations.issuedaterules"
                        dense
                        required
                        outlined
                        type="date"
                        :max="currentDate"
                      />
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("Location")
                        }}<span
                          v-if="editedItem.id_type_code === 'Passport'"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-autocomplete
                        v-if="validationFields.includes('ID Number')"
                        v-model="editedItem.id_issue_country"
                        item-text="name"
                        item-value="id"
                        :items="country_options"
                        :rules="validations.issue_locationRules"
                        :placeholder="$t('Location')"
                        dense
                        outlined
                        required
                        :min="currentDate"
                      />
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="!isMykad && !kycStatus"
                    >
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("expiryDate")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.id_expiry_date"
                        v-if="validationFields.includes('ID Number')"
                        :rules="validations.expDateRules"
                        dense
                        outlined
                        required
                        type="date"
                        :min="currentDate"
                      />
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('ID Number')"
                    >
                      <label class="ma-0 pa-0"
                        >{{ $t("idNumber")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.id_number"
                        :rules="validations.id_numberRules"
                        :placeholder="$t('id_number_placeholder')"
                        outlined
                        required
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('ID Number')"
                    >
                      <label class="ma-0 pa-0"
                        >{{ $t("IDFirstPage")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-file-input
                        v-model="editedItem.ID_First_Page"
                        :rules="validations.firstpage_rules"
                        dense
                        accept="image/png, image/jpeg, image/bmp"
                        :placeholder="$t('idtype_first_page_placeholder')"
                        outlined
                        ref="idfirstfile"
                        required
                        prepend-icon=""
                      >
                        <template v-slot:append>
                          <v-icon
                            aria-hidden="false"
                            class="color-primary"
                            @click="openIdfirst"
                          >
                            mdi-cloud-upload
                          </v-icon>
                        </template>

                        <template v-slot:append-outer>
                          <v-img
                            v-if="frontPageUrl && editedItem.ID_First_Page"
                            class="ml-1"
                            max-height="40"
                            max-width="50"
                            :src="frontPageUrl"
                            @click="handleImageViewer(frontPageUrl)"
                          />
                        </template>
                      </v-file-input>
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('ID Number')"
                    >
                      <label class="ma-0 pa-0">{{ $t("IDLastPage") }}</label>
                      <v-file-input
                        v-model="editedItem.ID_Last_Page"
                        dense
                        accept="image/png, image/jpeg, image/bmp"
                        :placeholder="$t('idtype_last_page_placeholder')"
                        outlined
                        ref="idlastfile"
                        required
                        prepend-icon=""
                      >
                        <template v-slot:append>
                          <v-icon
                            aria-hidden="false"
                            class="color-primary"
                            @click="openIdlast"
                          >
                            mdi-cloud-upload
                          </v-icon>
                        </template>

                        <template v-slot:append-outer>
                          <v-img
                            v-if="backPageUrl && editedItem.ID_Last_Page"
                            class="ml-1"
                            max-height="40"
                            max-width="50"
                            :src="backPageUrl"
                            @click="handleImageViewer(backPageUrl)"
                          />
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-divider class="p-o m-0"></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  outlined
                  @click="close" :disabled="isSaving"
                  v-if="!editedItem.biz_user_id"
                >
                  {{ $t("cancel_label") }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="onClickNext()" :loading="isSaving" :disabled="isSaving"
                  v-if="!editedItem.biz_user_id"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  color="primary"
                  outlined
                  @click="close" :disabled="isSaving"
                  v-if="editedItem.biz_user_id"
                >
                  {{ $t("cancel_label") }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="update()" :loading="isSaving" :disabled="isSaving"
                  v-if="editedItem.biz_user_id"
                >
                  {{ $t("update_label") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">
                {{ $t("want_to_delete_info") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">
                  {{ $t("cancel_label") }}</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                  {{ $t("okay") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-menu :offset-x="true" open-on-hover v-if="is_shareholder">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="v-custome-btn ms-2"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon dark left>mdi-account-plus </v-icon
                >{{ $t("add_shareholder") }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item link @click="showindDialog = true">
                <v-list-item-title
                  ><v-icon class="mb-1 me-2"> mdi-account-tie</v-icon>
                  {{ $t("individual") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item link @click="showBusDialog = true">
                <v-list-item-title
                  ><v-icon class="mb-1 me-2">mdi-briefcase-account</v-icon>
                  {{ $t("business") }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            color="primary"
            outlined
            small
            class="ms-2"
            :disabled="!getinformation.length || isLoading"
            @click="exportAuthorizationInfo"
          >
            <v-icon left>mdi-download</v-icon>
            {{ $t("export_label") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-col lg="6" sm="12" class="">
            <v-text-field
              v-model="search"
              append-icon="mdi-filter"
              :placeholder="$t('search_to_filter')"
              class=" "
              color="primary"
              outlined
              hide-details
              dense
            ></v-text-field>
          </v-col>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="showindDialog" width="700px" persistent>
      <v-col cols="12" class="p-0">
        <shareholder-ind
          v-if="showindDialog"
          @closeDialog="closeDialog"
          @getapplicant="getapplicant"
          :showindDialog="showindDialog"
        /> </v-col
    ></v-dialog>
    <v-dialog v-model="showBusDialog" width="700px" persistent>
      <v-col cols="12" class="p-0">
        <shareholder-bus
          v-if="showBusDialog"
          @closeBusDialog="closeBusDialog"
          @getapplicant="getapplicant"
          :showBusDialog="showBusDialog"
        /> </v-col
    ></v-dialog>

    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { i18n as $ } from "../../../locale/index";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { email, required, requiredIf } from "vuelidate/lib/validators";
import { findDatePrevious } from "../../../utils/helper";
import { alpha } from "../../../utils/validate";
import { BusUserTypes } from "../../../utils/BusDocuments";
import validatemixin from "@/mixins/Busvalidate.mixin";
import imageViewer from "../../tools/imageViewer.vue";
import handleImageUpload from "../../../mixins/compressImage.mixin";
import ShareholderInd from "./ShareholderInd.vue";
import ShareholderBus from "./ShareholderBus.vue";
import commonService from "@/services/AgentCommonService/commonService.js";
import AgentService from "@/services/agentService/AgentService";
import alerts from "@/mixins/alerts";
import digitsOnly from "@/directives/digitsOnly";
export default {
  directives: { digitsOnly },
  mixins: [validatemixin, handleImageUpload, alerts],
  data: () => ({
    id_type: "",
    dialog: false,
    showindDialog: false,
    showBusDialog: false,
    search: "",
    valid: true,
    currentDate: new Date().toJSON().split("T")[0],
    buscheckboxes: BusUserTypes(),
    Entitycheckbox: [],
    validationFields: [],
    backPageUrl: null,
    frontPageUrl: null,
    dialogDelete: false,
    dobmenu: false,
    kycStatus: null,
    disableBystatus: null,
    id_type_back: null,
    issue_location: null,
    maxDate: "",
    minDate: "",
    isDobError: false,
    expriydate: false,
    isValidNumber: false,
    country_options: [],
    relation_options: [],
    idtypes: [],
    idtypes_val: [],
    idtype_objs: [],
    nationality_options: [],
    occupation_options: [],
    occupation_objs: [],
    genderOptions: [
      { text: "Male", value: "M" },
      { text: "Female", value: "F" },
    ],
    isSubmitted: false,
    isUploading: false,
    isSaving: false,
    isLoading: false,
    loader: false,
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
    countrySelected: {},
    headers: [
      {
        text: "Name/Company",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      { text: "ID type", value: "id_type", sortable: false },
      { text: "ID number", value: "id_number", sortable: false },
      { text: "Designation", value: "applicant_type", sortable: false },
      { text: "Nationality", value: "nationality", sortable: false },
      { text: "DOB/DOI", value: "dob", sortable: false },
      { text: "Email", value: "email_id", sortable: false },
      { text: "Contact Number", value: "phone_number", sortable: false },
      { text: "Employer Name", value: "employee_name", sortable: false },
      {
        text: "Shareholding (%)",
        value: "percentage_of_shares",
        sortable: false,
      },
      {
        text: "Number of Shares",
        value: "no_of_shares",
        sortable: false,
      },
      {
        text: "Nature of Business",
        value: "nature_of_business",
        sortable: false,
      },
      {
        text: "Occupation",
        value: "occupation",
        sortable: false,
      },
      { text: "First page", value: "id_first_page", sortable: false },
      { text: "Last page", value: "id_last_page", sortable: false },
    ],
    getinformation: [],
    editedIndex: -1,
    biz_user_id: "",
    imageViewerUrl: "",
    isImageViewer: false,
    userId: null,
    editedItem: {
      applicant_type: [],
      full_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "Malaysia",
      biz_user_id: null,
    },
    deleteId: "",
    defaultItem: {
      applicant_type: [],
      full_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "Malaysia",
      biz_user_id: null,
    },
    validations: {
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [
        (v) => !!v || $.t("issueDateMsg1"),
        (v) => !v || v <= new Date().toJSON().split("T")[0] || $.t("issue_date_valid"),
      ],
      issue_locationRules: [],
      expDateRules: [
        (v) => !!v || $.t("expiryDateMsg1"),
        (v) => !v || v > new Date().toJSON().split("T")[0] || $.t("expiry_date_issue_validate"),
      ],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
      sharesRules: [
        (v) => !!v || $.t("no_ofshares"),
        (v) => (v > 25 && v < 100) || $.t("no_ofsharesmsg"),
      ],
    },
    is_shareholder: true,
  }),
  name: "BasicDetails",
  components: {
    VuePhoneNumberInput,
    imageViewer,
    ShareholderInd,
    ShareholderBus,
  },
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
    selctedEntity: {
      type: String,
    },
  },
  computed: {
    isMykad() {
      return String(this.editedItem.id_type_code) === "1";
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Management Info"
        : "Edit Management Info";
    },
    ...mapGetters("Transactional", [
      "realtion_list",
      "nationality_list",
      "occupation_list",
    ]),
    ...mapGetters("Authentication", ["country_list"]),
    applicantErrors() {
      const errors = [];
      if (!this.$v.editedItem.applicant_type.$dirty) return errors;
      !this.$v.editedItem.applicant_type.required &&
        errors.push(this.$t("usertype_req"));
      return errors;
    },
    fnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.full_name.$dirty) return errors;
      !this.$v.editedItem.full_name.required &&
        errors.push(this.$t("full_name"));
      !this.$v.editedItem.full_name.alpha &&
        errors.push(this.$t("invalid_full_name"));
      return errors;
    },

    designationErrors() {
      const errors = [];
      if (!this.$v.editedItem.occupation_code.$dirty) return errors;
      !this.$v.editedItem.occupation_code.required &&
        errors.push(this.$t("select_occupation"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email_id.$dirty) return errors;
      !this.$v.editedItem.email_id.required &&
        errors.push(this.$t("email_errors"));
      !this.$v.editedItem.email_id.email &&
        errors.push(this.$t("invalid_email"));
      return errors;
    },

    nationalityErrors() {
      const errors = [];
      if (!this.$v.editedItem.nationality_code.$dirty) return errors;
      !this.$v.editedItem.nationality_code.required &&
        errors.push(this.$t("nationality"));
      return errors;
    },

    DOBerrors() {
      const errors = [];
      if (!this.$v.editedItem.dob.$dirty) return errors;
      !this.$v.editedItem.dob.required && errors.push(this.$t("select_dob"));
      if (this.isDobError) {
        errors.push(this.$t("invalid_dob"));
      }
      return errors;
    },
  },

  watch: {
    isActive(active) {
      if (active) this.getapplicant();
    },
    isMykad: "clearMykadDates",
    "editedItem.id_issue_date": "clearMykadDates",
    "editedItem.id_expiry_date": "clearMykadDates",
    "editedItem.applicant_type"(applicant_type) {
      console.log("applicant_type", applicant_type);
      this.validationFields = [...this.getRequired(applicant_type)];
      console.log("applicant_type:", this.getRequired(applicant_type));
    },
    selctedEntity: {
      handler(newval) {
        console.log("treatEntityName", newval);
        this.EntityName = newval;
        this.returnBusCheckbox(newval, this.buscheckboxes);
        console.log(" this.EntityName ", newval);
      },
    },
    "editedItem.id_type"(val) {
      this.idtype_objs.map((i) => {
        if (val === i.parameter_value) {
          this.id_type_code = i.parameter_code;
        }
      });
    },
    "editedItem.id_type_code"(val) {
      if (String(val) === "1") {
        this.editedItem.id_expiry_date = null;
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    id_type(val) {
      this.idtype_objs.map((i) => {
        if (val === i.value) {
          this.id_type_code = i.id;
        }
      });
      if (val == "MYKAD" || val == "MyPR") {
        this.editedItem.id_issue_country = "Malaysia";
        this.disableIssueLoc = true;
      } else {
        // this.user_details.issue_location = "";
        this.disableIssueLoc = false;
      }
      if (val === "Passport") {
        this.validations.issue_locationRules = [
          (v) => !!v || $.t("issue_location_placeholder"),
        ];
      } else {
        this.validations.issue_locationRules = [];
      }
    },

    "editedItem.issue_location"(val) {
      this.country_objs.map((i) => {
        if (val === i.name) {
          this.issue_location_code = i.iso3;
        }
      });
    },


    countrySelected(newVal) {
      console.log("Selected country", newVal);
      if (Object.keys(newVal).length > 0) {
        this.editedItem.country_code = newVal.name;
        this.editedItem.applicant_country_code = newVal.iso3;
      }
    },
  },

  created() {
    // this.initialize();
  },
  validations() {
    return {
      editedItem: {
        applicant_type: {
          required,
        },
        full_name: {
          required: requiredIf(function () {
            if (this.validationFields.includes("Full Name")) return true;
            else return false;
          }),
          alpha,
        },
        nationality_code: {
          required: requiredIf(function () {
            if (this.validationFields.includes("Nationality")) return true;
            else return false;
          }),
        },
        occupation_code: {
          required: requiredIf(function () {
            if (this.validationFields.includes("Designation")) return true;
            else return false;
          }),
        },
        email_id: {
          required,
          email,
        },

        dob: {
          required: requiredIf(function () {
            if (this.validationFields.includes("DOB")) return true;
            else return false;
          }),
        },
      },
    };
  },
  mounted() {
    this.returnBusCheckbox(this.selctedEntity, this.buscheckboxes);
    this.getOccupation();
    this.getNationalityList();
    this.getidtypes();
    this.getapplicant();

    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
  },

  methods: {
    getAuthorizationExportValue(item, field) {
      const valueByField = {
        id_type: item.id_type?.value || item.id_type,
        applicant_type: item.applicant_type || item.type,
        nationality:
          item.nationality?.nationality ||
          item.nationality?.value ||
          item.nationality,
        percentage_of_shares:
          item.percentage_of_shares ??
          item.share_holding_percentage ??
          item.no_of_shares,
        nature_of_business:
          item.nature_of_business?.value || item.nature_of_business,
        occupation: item.occupation?.value || item.occupation,
        id_first_page: item.id_first_page || item.first_page,
        id_last_page: item.id_last_page || item.last_page,
      };
      const value = Object.prototype.hasOwnProperty.call(valueByField, field)
        ? valueByField[field]
        : item[field];

      if (Array.isArray(value)) return value.join("; ");
      if (value && typeof value === "object") {
        return value.value || value.name || value.text || JSON.stringify(value);
      }
      return value ?? "";
    },
    escapeCsvValue(value) {
      const text = String(value);
      const spreadsheetSafeText = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
      return `"${spreadsheetSafeText.replace(/"/g, '""')}"`;
    },
    exportAuthorizationInfo() {
      if (!this.getinformation.length) return;

      const columnHeaders = this.headers.map((header) => header.text);
      const rows = this.getinformation.map((item) =>
        this.headers.map((header) =>
          this.getAuthorizationExportValue(item, header.value),
        ),
      );
      const csvContent = [columnHeaders, ...rows]
        .map((row) => row.map(this.escapeCsvValue).join(","))
        .join("\r\n");
      const file = new Blob(["\ufeff", csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const fileUrl = URL.createObjectURL(file);
      const downloadLink = document.createElement("a");
      const date = new Date().toISOString().slice(0, 10);

      downloadLink.href = fileUrl;
      downloadLink.download = `management-information-${date}.csv`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(fileUrl);
    },
    clearMykadDates() {
      if (this.isMykad) {
        this.editedItem.id_issue_date = null;
        this.editedItem.id_expiry_date = null;
      }
    },
    closeDialog() {
      this.showindDialog = false;
    },
    closeBusDialog() {
      this.showBusDialog = false;
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    async getapplicant() {
      if (!this.$route.query.login_id || !this.$route.query.customer_id || !this.isActive) return;
      this.isLoading = true;
      try {
        const responseData = await AgentService.getAllApplicantsinfo({
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.getinformation = [...responseData.data.data].reverse();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.isLoading = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },
    returnBusCheckbox(val, documents) {
      console.log("doc val", val);
      console.log("doc", documents);
      for (let doc in documents) {
        console.log("doc in", doc);
        if (doc === val) {
          console.log("doc did", documents[doc]);
          this.Entitycheckbox = documents[doc].list;
          this.is_shareholder = documents[doc].is_shareholder;
        }
      }
    },
    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC", "IND");
        if (responseData.data.status_code === 200) {
          this.occupation_options = responseData.data.data.map((i) => {
            this.occupation_objs.push(i);
            return {
              name: i.value,
              id: i.value_code,
            };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async fileUpload(fileObject, biz_user_id, doc_type) {
      // Existing document URLs and empty optional fields do not need uploading.
      if (!(fileObject instanceof Blob)) return;
      const compressedFile = await this.handleImageUpload(fileObject);
      if (!compressedFile) throw new Error("Unable to prepare the selected document");
      const fileData = new FormData();
      fileData.append("document", compressedFile);
      const response = await AgentService.UploadApplicantFiles(fileData, {
        login_id: this.$route.query.login_id,
        customer_id: this.$route.query.customer_id,
        biz_user_id,
        doc_type,
      });
      if (!(response?.data?.success === true || Number(response?.data?.status_code) === 200)) {
        throw new Error(response?.data?.message || "Document upload failed");
      }
    },
    async getidtypes() {
      try {
        const responseData = await commonService.getparameterdropdowns("DOC", "IND");
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((idtype) => {
            this.idtypes.push(idtype.value);
            this.idtypes_val.push({
              name: idtype.value,
              id: idtype.value_code,
            });
            this.idtype_objs.push(idtype);
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onChangeNumber(e) {
      this.isValidNumber = Boolean(e && e.isValid);
    },
    async getNationalityList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((i) => {
            this.country_options.push({
              name: i.country_name,
              id: i.iso_alpha3,
            });
            this.nationality_options.push({
              name: i.nationality,
              id: i.iso_alpha3,
            });
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    editItem(item) {
      this.editedIndex = this.getinformation.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.applicant_type = item.type;
      console.log("image data", item.type);
      this.idtype_objs.map((ele) => {
        console.log("ele", ele);
        if (ele.value == item.id_type_code) {
          this.editedItem.id_type_code = ele.value_code;
        }
      });
      this.editedItem.ID_First_Page = item.first_page
        ? {
            name: item.first_page?.split("/").pop(),
            value: item.first_page,
          }
        : null;

      this.editedItem.ID_Last_Page = item.last_page
        ? {
            name: item.last_page?.split("/").pop(),
            value: item.last_page,
          }
        : null;
      this.backPageUrl = item.last_page ? item.last_page : null;
      this.frontPageUrl = item.first_page ? item.first_page : null;
      this.editedItem.occupation_code = item.occupation_code
        ? item.occupation_code
        : null;
      // this.getapplicant();
      this.dialog = true;
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.biz_user_id;
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await AgentService.deleteApplicantInfo({
          biz_user_id: this.deleteId,
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getapplicant();
          this.loader = false;
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem, applicant_type: [] };
        this.countrySelected = {};
        this.frontPageUrl = null;
        this.backPageUrl = null;
        this.isDobError = false;
        this.$v.$reset();
        this.$refs.busApplicant?.resetValidation();
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },
    onClickNext() {
      console.log(`editedItem: ${JSON.stringify(this.editedItem)}`);
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.$refs.busApplicant.validate()) {
        return this.save();
      }
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    save() {
      return this.persistApplicant(Boolean(this.editedItem.biz_user_id));
    },
    update() {
      if (this.isSaving) return;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      if (this.$refs.busApplicant.validate()) {
        return this.updateData();
      }
    },
    updateData() {
      return this.persistApplicant(true);
    },
    async persistApplicant(isUpdate) {
      if (this.isSaving) return;
      this.isSaving = true;
      this.loader = true;
      this.clearMykadDates();
      this.alertMsg.status = false;
      let informationSaved = false;
      try {
        const params = {
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        };
        const response = isUpdate
          ? await AgentService.updateApplicantInfo(this.editedItem, {
              ...params,
              biz_user_id: this.editedItem.biz_user_id,
            })
          : await AgentService.addApplicantInfo(this.editedItem, params);
        const result = response?.data;
        if (!(result?.success === true || Number(result?.status_code) === 200)) {
          throw new Error(result?.message || "Please try again.");
        }
        const savedData = Array.isArray(result.data) ? result.data[0] : result.data;
        this.userId = savedData?.biz_user_id || this.editedItem.biz_user_id;
        if (!this.userId) throw new Error("The saved record ID is missing. Please refresh the list.");
        this.$set(this.editedItem, "biz_user_id", this.userId);
        informationSaved = true;
        await this.fileUpload(this.editedItem.ID_First_Page, this.userId, "ID_First_Page");
        await this.fileUpload(this.editedItem.ID_Last_Page, this.userId, "ID_Last_Page");
        await this.getapplicant();
        this.alertMsg.status = true;
        this.alertMsg.text = result.message;
        this.alertMsg.type = "success";
        this.alertMsg.color = "green";
        this.close();
      } catch (error) {
        this.alertMsg.status = true;
        this.alertMsg.text = informationSaved
          ? "Information saved, but documents could not be uploaded. Please retry Update: " + error.message
          : (isUpdate ? "Update" : "Creation") + " Failed: " + (error.response?.data?.message || error.message || "Please try again.");
        this.alertMsg.type = "error";
        this.alertMsg.color = "error";
      } finally {
        this.isSaving = false;
        this.loader = false;
      }
    },
  },
};
</script>
<style>
.v-input .v-label {
  margin-bottom: 0px !important;
}
</style>
